import { ShieldCheck, Flame } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const OPTIONS = [
  { value: "clean", icon: ShieldCheck, title: "Clean", desc: "Family-friendly. No profanity or mature themes.", accent: "border-emerald-500/50 hover:bg-emerald-500/10 text-emerald-500" },
  { value: "explicit", icon: Flame, title: "Explicit (18+)", desc: "Adults only. Profanity and mature themes allowed.", accent: "border-fuchsia-400/50 hover:bg-fuchsia-400/10 text-fuchsia-400" },
];

export const RatingDialog = ({ open, onOpenChange, onChoose, count = 1 }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-[#09090B] border-white/10 rounded-sm max-w-lg" data-testid="rating-dialog">
      <DialogHeader>
        <DialogTitle className="font-mono-display text-2xl tracking-tight">What kind of lyrics?</DialogTitle>
        <DialogDescription className="text-zinc-400">
          {count > 1 ? `Applies to all ${count} songs in this batch.` : "Pick this before we write the prompt and lyrics."}
        </DialogDescription>
      </DialogHeader>
      <div className="grid sm:grid-cols-2 gap-3 mt-2">
        {OPTIONS.map(({ value, icon: Icon, title, desc, accent }) => (
          <button
            key={value}
            type="button"
            onClick={() => onChoose(value)}
            data-testid={`rating-${value}-btn`}
            className={`text-left border p-5 rounded-sm transition-colors ${accent}`}
          >
            <Icon className="w-5 h-5 mb-3" />
            <div className="font-mono-display text-base font-bold text-white">{title}</div>
            <div className="text-sm text-zinc-400 mt-1">{desc}</div>
          </button>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);
